import PageLockScreen from './components/LockScreen';

export default PageLockScreen;


// WEBPACK FOOTER //
// ./routes/lock-screen/index.js